import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center py-1 container-lg"
}
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.node)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          href: "#",
          class: "btn btn-primary btn-sm",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('clickShare')), ["prevent"]))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "icon-share me-2" }, null, -1),
          _createTextVNode("シェア")
        ])),
        ((typeof _ctx.node.weight !== 'undefined') && _ctx.node.weight == 0)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#",
              class: "btn btn-primary btn-sm ms-2",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('clickMarking')), ["prevent"]))
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fas fa-plus me-2" }, null, -1),
              _createTextVNode("マイメモリーに追加")
            ])))
          : _createCommentVNode("", true),
        (_ctx.node.links.admin && _ctx.node.editable)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: _ctx.node.links.admin,
              class: "btn btn-default btn-sm ms-2"
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fas fa-edit me-2" }, null, -1),
              _createTextVNode("編集")
            ]), 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}